import axios from "axios";
import { API } from "../axios/API";



export const gestionService = {
  getGestionList,
  getActuacion,
  createActuacion,
  basexImp
};


async function getGestionList(data) {
  try {
    let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/cobrojud/recImpGstLeg.php", {
      data: {
        bsq: 1,
        ...data
      }
    });

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err.message;
  }
}


async function getActuacion(id) {
  try {
    let response = await API.get(`/actuaciones/${id}`);

    let result = response?.data;

    return result;
  }
  catch (err) {
    return err.message;
  }
}

async function createActuacion(data) {
  try {
    let newData = new FormData();

    for (const prop in data) {
      if (prop === "files") {
        data[prop].forEach((e, i) => {
          if (e) {
            newData.append(`file_${i}`, e.originFileObj);
          }
        });
      }
      else if(prop === "imponibles"){
        newData.append(`${prop}`, JSON.stringify(data[prop]));
      }
      else {
        newData.append(`${prop}`, data[prop]);
      }
    }
    const response = await API.post("/actuaciones", newData);


    return response.data;
  }
  catch (err) {
    return err.message;
  }
}

async function basexImp(data) {
  // return arrayData;
  try {
    const response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/consultas/basexImp.php", { data });

    if (response.data?.mensaje) return response.data?.mensaje;

    return response?.data;
  } catch (err) {
    console.log(err);
    return err.response;
  }
}